import useEmblaCarousel from 'embla-carousel-react'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import researchContent from '../../content/research'
import LinkComponent from '../LinkComponent/LinkComponent'
import { InfoCard } from 'component-library'
import { sendCustomGAEvent } from 'shared-utilities'
import './ResearchDemos.scss'

const { title, description, callToAction } = researchContent.featuredDemos

export const DESKTOP_DEMOS_CONTAINER_ID = `research-demos-desktop`
export const MOBILE_DEMOS_CONTAINER_ID = `research-demos-mobile`

const DemoTag = () => (
  <span className="flex items-center gap-2 text-grey-9">
    <i className="bx bxs-flask"></i> <span className="text-footnote">Demo</span>
  </span>
)

const ResearchDemos = ({
  featuredDemos,
}: {
  featuredDemos: Queries.GetFeaturedResearchDemosQuery['allMarkdownRemark']['nodes']
}) => {
  const [emblaRef] = useEmblaCarousel({ loop: false, dragFree: true }, [
    WheelGesturesPlugin({ forceWheelAccess: 'x' }),
  ])

  return (
    <div className="ResearchDemos ">
      <div className="container">
        <h3 className="text-h3 mb-3">{title}</h3>
        <p className="text-s2 mb-6">{description}</p>
        <div
          className={`ResearchDemos__Desktop ${
            featuredDemos.length < 3 ? 'justify-center' : 'grid-cols-3'
          }`}
          id={DESKTOP_DEMOS_CONTAINER_ID}
        >
          {featuredDemos.map((demo) => (
            <LinkComponent
              key={demo.frontmatter?.slug}
              href={`/qml/demos/${demo.frontmatter?.slug}` || ''}
              testId={`research-demo-tile-${demo.frontmatter?.slug}`}
              onClick={() => {
                sendCustomGAEvent('click', {
                  event_category: 'research_page_demos',
                  event_label: 'demo_card_link',
                  value: demo.frontmatter?.slug,
                })
              }}
              openInCurrentTab
            >
              <InfoCard
                label={demo.frontmatter?.title || ''}
                image={
                  demo.frontmatter?.previewImages &&
                  demo.frontmatter?.previewImages.length &&
                  demo.frontmatter?.previewImages[0]?.uri
                    ? demo.frontmatter?.previewImages[0]?.uri
                    : ''
                }
                tag={<DemoTag />}
              />
            </LinkComponent>
          ))}
        </div>
      </div>
      <div
        className="ResearchDemosCarousel"
        ref={emblaRef}
        id={MOBILE_DEMOS_CONTAINER_ID}
      >
        <div className="ResearchDemosCarousel__container">
          {featuredDemos.map((demo) => (
            <div
              className="ResearchDemosCarousel__slide"
              key={demo.frontmatter?.slug}
            >
              <LinkComponent
                key={demo.frontmatter?.slug}
                href={`/demos/${demo.frontmatter?.slug}` || ''}
                testId={`research-demo-tile-${demo.frontmatter?.slug}`}
                onClick={() => {
                  sendCustomGAEvent('click', {
                    event_category: 'research_page_demos',
                    event_label: 'demo_card_link',
                    value: demo.frontmatter?.slug,
                  })
                }}
                openInCurrentTab
              >
                <InfoCard
                  label={demo.frontmatter?.title || ''}
                  image={
                    demo.frontmatter?.previewImages &&
                    demo.frontmatter?.previewImages.length &&
                    demo.frontmatter?.previewImages[0]?.uri
                      ? demo.frontmatter?.previewImages[0]?.uri
                      : ''
                  }
                  tag={<DemoTag />}
                />
              </LinkComponent>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-center mt-6">
        <LinkComponent
          href={callToAction.link}
          className="Bottom__link"
          testId="research-demos-cta"
          onClick={() => {
            sendCustomGAEvent('click', {
              event_category: 'research_page_demos',
              event_label: callToAction.label,
              value: callToAction.link,
            })
          }}
        >
          {callToAction.label}
          <i className="bx bx-chevron-right" />
        </LinkComponent>
      </div>
    </div>
  )
}

export default ResearchDemos
